/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Form } from '@organisms';

import FilterSelect from '../FilterSelect';

const FilterField = ({ onChange, queryVariables, ...props }) => (
  <Form.Item {...props}>
    <FilterSelect onChange={onChange} queryVariables={queryVariables} />
  </Form.Item>
);

export default FilterField;
